import { PaymentMode } from './use-payments-helper';

const storageKey = (shortLink: string) => `payments-sdk-last-mode-${shortLink}`;

export const persistLastPaymentMode = (shortLink: string, mode: PaymentMode) => {
    if (!shortLink) return;
    sessionStorage.setItem(storageKey(shortLink), mode);
};

export const getLastPaymentMode = (
    shortLink: string,
    fallback: PaymentMode = PaymentMode.UPI
): PaymentMode => {
    if (!shortLink) return fallback;
    const stored = sessionStorage.getItem(storageKey(shortLink));
    if (stored && Object.values(PaymentMode).includes(stored as PaymentMode)) {
        return stored as PaymentMode;
    }
    return fallback;
};

export const clearLastPaymentMode = (shortLink: string) => {
    if (!shortLink) return;
    sessionStorage.removeItem(storageKey(shortLink));
};
